import { render, staticRenderFns } from "./SubmittedDocumentsModal.vue?vue&type=template&id=c6dcb378&scoped=true"
import script from "./SubmittedDocumentsModal.vue?vue&type=script&lang=js"
export * from "./SubmittedDocumentsModal.vue?vue&type=script&lang=js"
import style0 from "./SubmittedDocumentsModal.vue?vue&type=style&index=0&id=c6dcb378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dcb378",
  null
  
)

export default component.exports